import { render, staticRenderFns } from "./honor-box.vue?vue&type=template&id=9b054cfe&scoped=true"
import script from "./honor-box.vue?vue&type=script&lang=js"
export * from "./honor-box.vue?vue&type=script&lang=js"
import style0 from "./honor-box.vue?vue&type=style&index=0&id=9b054cfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b054cfe",
  null
  
)

export default component.exports